// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__7NON3","ellipsis":"styles_ellipsis__xPe4f","text2AndMoreLines":"styles_text2AndMoreLines__2g_1s","tooltipTrigger":"styles_tooltipTrigger__ahiGR"};